import c from 'classnames';
import { useEditorStateToHtml } from '../hooks';
import styles from './EditorStateAsHtml.module.css';

type UseEditorStateToHtmlArgs = Parameters<typeof useEditorStateToHtml>;

type Props = {
  getEditorStateFnOrKey: UseEditorStateToHtmlArgs[0];
  deps: UseEditorStateToHtmlArgs[1];
  className?: string;
};

export function EditorStateAsHtml({
  getEditorStateFnOrKey,
  deps,
  className,
}: Props) {
  const { html } = useEditorStateToHtml(getEditorStateFnOrKey, deps);

  if (!html) return null;

  return (
    <div
      className={c(className, styles.htmlContainer)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
